export const environment = {
  production: true,
  dev: false,
  apiUrl: 'https://paced.tmu.edu.tw/api/',
  googleCalendarApiKey: 'AIzaSyBb43UFat8UYLrwR8W4xNJfYK_7QL5Pl60',   //tmu
  oauth: '543207587194-pv41sbpka2qle4gm85d3ir6oh3o8pbjc.apps.googleusercontent.com'  //tmu
};
